import { createContext as T, useState as v, useContext as E, useRef as h, useImperativeHandle as x, useEffect as O } from "react";
const g = "--builders-chart-color", m = "--builders-chart-color-text", y = "aria-label", l = "aria-describedby", b = "data-value", L = T(null), R = (n, e) => {
  var s;
  const [o, c] = v(""), t = (s = E(L)) == null ? void 0 : s.tooltip, r = Object.hasOwnProperty.call(n || {}, "content") ? n : { content: n ?? e };
  return !t && !n ? {} : Object.assign(
    {
      tooltipProps: { "data-legend": o },
      onOpen: ({ currentTarget: a }) => {
        var i;
        const d = a.getAttribute(l) || "", u = ((i = document.getElementById(d)) == null ? void 0 : i.innerText) || "";
        o !== u && c(u);
      }
    },
    t,
    r
  );
}, $ = (n) => {
  const { legends: e } = E(L) || {}, [o, c] = v([]), t = h(null);
  return x(n, () => t.current), O(() => {
    const r = () => c(C(t, e)), s = new MutationObserver(r);
    return r(), t.current && s.observe(t.current, {
      attributeFilter: [b],
      attributes: !0,
      childList: !0,
      subtree: !0
    }), () => s.disconnect();
  }, [e]), [o, t];
}, C = ({ current: n }, e) => {
  const o = /* @__PURE__ */ new Map(), c = [];
  return n == null || n.querySelectorAll(`[${b}]`).forEach((t) => {
    var A;
    const r = t.getAttribute(b) || "false", s = (o.get(t.parentElement) || 0) + 1, a = t.getAttribute("data-legend"), d = (e == null ? void 0 : e[s - 1]) || "", u = (e == null ? void 0 : e.length) === 1 && "single", i = !Number.isNaN(Number(r)), f = r === "legend";
    if (t[i ? "setAttribute" : "removeAttribute"](y, `${r}`), (i || f) && c.push({ el: t, value: Number(r) }), a === "inherit") {
      const p = (A = t.parentElement) == null ? void 0 : A.closest(`[${b}]`);
      t.setAttribute(l, (p == null ? void 0 : p.getAttribute(l)) || "");
    } else
      a !== "skip" && (o.set(t.parentElement, s), t.style.setProperty(g, `var(${g}-${u || s})`), t.style.setProperty(m, `var(${m}-${u || s})`), f || t.setAttribute(l, d));
  }), c;
};
export {
  L as ChartContext,
  R as useTooltip,
  $ as useValues
};
//# sourceMappingURL=chart-utils.js.map
